module.exports = __webpack_public_path__ + "10_hige_gray.6089d8b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/10_hige_gray.png
// module id = qd/H
// module chunks = 0